import TextField from "@mui/material/TextField";
import Divider from "@mui/material/Divider";
import InputAdornment from "@mui/material/InputAdornment";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import LoginIcon from "@mui/icons-material/Login";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { Visibility } from "@mui/icons-material";
import { VisibilityOff } from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import * as React from "react";
import { useTokens } from "../../theme";

const DEFAULT_LOGIN = {
  email: "",
  password: "",
};

export default function LoginForm({ loginProps, dialogProps }) {
  const { showPassword, loginHandlers, isLoading } = loginProps;
  const { dialogHandlers } = dialogProps;
  const tokens = useTokens();
  const [loginForm, setLoginForm] = React.useState(DEFAULT_LOGIN);
  const [capsLock, setCapsLock] = React.useState(false);

  const handleInputChange = (fieldName, value) => {
    setLoginForm((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    loginHandlers.login(loginForm);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Stack spacing={0.5} sx={{ mb: 3 }}>
        <Typography
          component="h2"
          sx={{ fontSize: "1.25rem", fontWeight: 600, color: tokens.foreground }}
        >
          Sign in
        </Typography>
        <Typography sx={{ fontSize: "0.875rem", color: tokens.mutedForeground }}>
          Enter your email and password to access your dashboard.
        </Typography>
      </Stack>
      <Stack spacing={2}>
        <TextField
          id="login-form-email"
          label="Email"
          type="email"
          autoComplete="email"
          variant="outlined"
          fullWidth
          onChange={(event) => handleInputChange("email", event.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <MailOutlineIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        <TextField
          id="login-form-password"
          label="Password"
          variant="outlined"
          fullWidth
          autoComplete="current-password"
          type={showPassword ? "text" : "password"}
          onKeyUp={(event) => setCapsLock(event.getModifierState?.("CapsLock") ?? false)}
          onBlur={() => setCapsLock(false)}
          helperText={capsLock ? "Caps Lock is on" : undefined}
          onChange={(event) =>
            handleInputChange("password", event.target.value)
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon fontSize="small" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  aria-pressed={showPassword}
                  onClick={loginHandlers.toggle}
                  onMouseDown={loginHandlers.mouseDown}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
        <Button
          variant="text"
          size="small"
          type="button"
          onClick={dialogHandlers.open}
        >
          Forgot Password?
        </Button>
      </Box>
      <LoadingButton
        sx={{ mt: 2 }}
        variant="contained"
        size="large"
        type="submit"
        fullWidth
        startIcon={<LoginIcon />}
        loading={isLoading}
      >
        Sign In
      </LoadingButton>
      <Divider sx={{ my: 3, color: tokens.mutedForeground, fontSize: "0.75rem" }}>
        New to Sunsure?
      </Divider>
      <Button
        variant="outlined"
        size="large"
        type="button"
        fullWidth
        onClick={loginHandlers.newAccount}
      >
        Create New Account
      </Button>
    </Box>
  );
}
